export const toggleModal = "toggleModal"
export const ADD_REDEEM_REQUEST_TO_LIST = "ADD_REDEEM_REQUEST_TO_LIST"
export const UPDATE_REDEEM_REQUEST_IN_LIST = "UPDATE_REDEEM_REQUEST_IN_LIST"
export const DELETE_REDEEM_REQUEST_FROM_LIST = "DELETE_REDEEM_REQUEST_FROM_LIST"
export const ADD_REDEEMS_REQUEST_TO_LIST = "ADD_REDEEMS_REQUEST_TO_LIST"
